import * as React from 'react'
import { FC, useCallback } from 'react'
import { toast } from '@sales-center/components'
import { bulkUpdateNextActionDateLeads } from '@user/store/lead'
import {
  BulkActionsProps,
  BulkUpdateNextActionDate,
} from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = BulkActionsProps & { hasPermission: boolean }

export const LeadBulkUpdateNextActionDate: FC<Props> = ({
  selectedRows,
  hasPermission,
}) => {
  const dispatch = useAppDispatch()

  const updateCallback = useCallback(
    async (date: Date | null) => {
      const ids = [...selectedRows.keys()].map((k) => Number(k))

      const result = await dispatch(
        bulkUpdateNextActionDateLeads({
          ids: ids,
          nextActionDate: date,
        }),
      )

      if (bulkUpdateNextActionDateLeads.fulfilled.match(result)) {
        toast.success('Bulk update successfully applied')
        return true
      } else {
        if (result.payload) toast.error(result.payload.Message)
        return false
      }
    },
    [dispatch, selectedRows],
  )

  return (
    <BulkUpdateNextActionDate
      recordCount={selectedRows.size}
      saveCallback={updateCallback}
      hasPermission={hasPermission}
      entityType={ENTITY_TYPES.Lead}
    />
  )
}
LeadBulkUpdateNextActionDate.displayName = 'LeadBulkUpdateNextActionDate'
